import React, { useContext } from 'react';
import { BdsButton, BdsGrid, BdsIllustration, BdsPaper, BdsTypo, BdsModal } from 'blip-ds/dist/blip-ds-react';
import SubmitCertificate from '../SubmitCertificate';
import { useContentLocalizer } from '../../../../hooks/useContentLocalizer';
import { localization } from './localization';
import MtlsContext from '../../../../contexts/MtlsContext';

const CreateCertificate: React.FC = () => {
  const content = useContentLocalizer(localization);
  const { toggleSubmitModal } = useContext(MtlsContext);
  const certificateModal = document.getElementById('certificate-modal');
  const shadowRoot = certificateModal?.shadowRoot?.querySelector('.modal.modal--dynamic');
  shadowRoot?.setAttribute('style', 'margin: 0 auto;height: 500px;');
  return (
    <BdsPaper width="100%">
      <BdsGrid gap="8" margin="5">
        <BdsGrid>
          <BdsIllustration className="mtls-lock-illustration" type="spots" name="lock-2"></BdsIllustration>
        </BdsGrid>
        <BdsGrid direction="column" justifyContent="space-between">
          <BdsGrid direction="column" margin="b-2">
            <BdsTypo variant="fs-24" bold="bold" margin={true}>
              {content.title}
            </BdsTypo>
            <BdsTypo variant="fs-16">{content.subtitle}</BdsTypo>
          </BdsGrid>
          <BdsGrid>
            <BdsButton icon="add" onClick={toggleSubmitModal}>
              {content.button}
            </BdsButton>
            <BdsModal id="certificate-modal" size="dynamic">
              <SubmitCertificate />
            </BdsModal>
          </BdsGrid>
        </BdsGrid>
      </BdsGrid>
    </BdsPaper>
  );
};

export default CreateCertificate;
